import Icon from 'veui/components/Icon'
import { IconUser } from 'dls-icons-vue'

Icon.register('user', IconUser)
